import React from 'react'
import styled from 'styled-components'
import StyledText from '../../components/StyledComponents/StyledText'
import { useTheme } from '../../middleware/ThemeContext'

interface IconBox {
    icon: React.ReactNode,
    title: string,
}

const IconBox: React.FC<IconBox> = ({ icon, title }) => {
    const {theme} = useTheme();
  return (
    <IconCon>
        <div 
            className='mb-3 d-flex align-items-center justify-content-center'
            style={{ borderRadius: '12px', backgroundColor: theme.CorporateTheme.colors.white, width: '85px', height: '85px' }}
        >
            <div 
            className='d-flex align-items-center justify-content-center'
            style={{ width: '49px', height: '49px', borderRadius: '10.5px', background: 'linear-gradient(205.82deg, rgba(0, 80, 255, 0.05) 16.3%, rgba(0, 80, 255, 0.05) 86.48%)' }}>
                {icon}
            </div>
        </div>
        <StyledText
            htmlTag={'span'}
            textColor={theme.CorporateTheme.colors.headerColor}
            fontSize='14px'
            fontWeight={600}
        >
            {title}
        </StyledText>
    </IconCon>
  )
}

export default IconBox

const IconCon = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    z-index: 1;
`;